import { API_VERSION } from './define';
import { callFetch } from './response';
import { authAccessTokenHeader } from './settings';

const resource = 'booking';

const EndPoint = {
    BookAppointment: () => `/${API_VERSION}/${resource}`,
    SignupAppointment: (appointmentId) => `/${API_VERSION}/${resource}/${appointmentId}/signup`,
    CancelAppointment: (appointmentId) => `/${API_VERSION}/${resource}/${appointmentId}`,
    GetAppointment: (appointmentId) => `/${API_VERSION}/${resource}/${appointmentId}`,
    GetAppointment: (appointmentId) => `/${API_VERSION}/${resource}/${appointmentId}`,
    GetAppointmentsByEventIds: (eventIds) => `/${API_VERSION}/${resource}?eventIds=${eventIds}`
};

// activity

export function bookAppointment(data, accessToken) {
    const uri = EndPoint.BookAppointment();

    let settings = {
        method: 'POST',
        headers: { ...authAccessTokenHeader(accessToken) },
        body: JSON.stringify(data)
    };

    return callFetch(uri, settings);
}

export function signupAppointment(appointmentId, data, accessToken) {
    const uri = EndPoint.SignupAppointment(appointmentId);
    let settings = {
        method: 'POST',
        headers: { ...authAccessTokenHeader(accessToken) },
        body: JSON.stringify(data)
    };

    return callFetch(uri, settings);
}

export function getAppointmentsByEventIds(eventIds, accessToken) {
    const uri = EndPoint.GetAppointmentsByEventIds(eventIds);
    let settings = {
        method: 'GET',
        headers: { ...authAccessTokenHeader(accessToken) }
    };

    return callFetch(uri, settings);
}

export function getAppointmentById(appointmentId, accessToken) {
    const uri = EndPoint.GetAppointment(appointmentId);
    let settings = {
        method: 'GET',
        headers: { ...authAccessTokenHeader(accessToken) }
    };

    return callFetch(uri, settings);
}

export function getAppointmentByLineId(lineId, accessToken) {
    const uri = EndPoint.GetAppointment(lineId);
    let settings = {
        method: 'GET',
        headers: { ...authAccessTokenHeader(accessToken) }
    };

    return callFetch(uri, settings);
}

export function cancelAppointment(appointmentId, accessToken) {
    const uri = EndPoint.CancelAppointment(appointmentId);
    let settings = {
        method: 'DELETE',
        headers: { ...authAccessTokenHeader(accessToken) }
    };

    return callFetch(uri, settings);
}
